import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { adminClient } from '@/lib/adminClient';
import type { AdminAudience } from '@/api/types';

export const pushAnnouncementKeys = {
  all: ['push-announcements'] as const,
  list: (params: Record<string, string | number | undefined>) =>
    [...pushAnnouncementKeys.all, 'list', params] as const,
};

export function usePushAnnouncements(params: { limit?: number; offset?: number } = {}) {
  return useQuery({
    queryKey: pushAnnouncementKeys.list(params),
    queryFn: () => adminClient.listPushAnnouncements(params),
    // Scheduled → sending → sent transitions happen server-side; poll so the
    // table reflects them without a manual refresh.
    refetchInterval: 15_000,
  });
}

export function useCreatePushAnnouncement() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { title: string; message: string; url?: string; sendAt?: string; audience?: AdminAudience }) =>
      adminClient.createPushAnnouncement(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: pushAnnouncementKeys.all });
    },
  });
}

export function useCancelPushAnnouncement() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => adminClient.cancelPushAnnouncement(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: pushAnnouncementKeys.all });
    },
  });
}
